module.exports = __webpack_public_path__ + "static/media/afghanistanView.b068e406.svg";